


























import { ObjectFactory } from '@/config/objectFactory';
import { Component, Vue } from 'vue-property-decorator';
import '../../assets/css/ServiceRequestDetails.scss';
@Component({
    props: {
        selectedPlan: String,
    },
})
export default class SubscriptionPlanConfirmationModal extends Vue {
    private selectedSubscriptionPlan: string = '';
    private show = true;

    private mounted() {
        this.selectedSubscriptionPlan = this.$props.selectedPlan;
    }
    private async activateSubscriptionPlan() {
        this.$emit('activate', this.selectedSubscriptionPlan);
        this.close();
    }
    private close() {
        this.$emit('close');
    }
}
